import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { API_ADVERT_DETAIL_NAME, INIT_URL, LOAD_REVIEWS_URL } from '#advertDetail/constants';
import { InitResponseType, LoadReviewsPayloadType, LoadReviewsResponseType } from '#advertDetail/api';

const getApiAdvertDetail = (diContainer: Container) => createApi({
  reducerPath: API_ADVERT_DETAIL_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    init: builder.query<InitResponseType, number>({
      query: (id) => ({
        url: INIT_URL,
        params: {
          id,
        },
      }),
    }),
    loadReviews: builder.query<LoadReviewsResponseType, LoadReviewsPayloadType>({
      query: ({ id, page }) => ({
        url: LOAD_REVIEWS_URL,
        params: {
          id,
          page,
        },
      }),
    }),
  }),
});

export { getApiAdvertDetail };
